import { useEffect, useState } from "react";
import "./InativarOrigemCarregamentoTrilhosNovosModal.css";

export default function InativarOrigemCarregamentoTrilhosNovosModal({ open, titulo, onClose, onConfirmar }) {
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState("");

  useEffect(() => {
    if (!open) return;
    setBusy(false);
    setErr("");
    const prev = document.body.style.overflow;
    document.body.style.overflow = "hidden";
    return () => {
      document.body.style.overflow = prev;
    };
  }, [open]);

  if (!open) return null;

  async function handleConfirmar() {
    if (busy) return;
    setBusy(true);
    setErr("");
    try {
      await onConfirmar?.();
      onClose?.();
    } catch (e) {
      setErr(e?.response?.data?.error || e?.message || "Falha ao inativar.");
    } finally {
      setBusy(false);
    }
  }

  return (
    <div className="ocnin-bg" onClick={onClose}>
      <div className="ocnin-box" role="dialog" aria-modal="true" aria-label="Inativar origem novos" onClick={(e) => e.stopPropagation()}>
        <header className="ocnin-head">
          <h3 className="ocnin-title">Inativar</h3>
          <button className="ocnin-x" onClick={onClose} type="button" aria-label="Fechar" disabled={busy}>x</button>
        </header>
        <div className="ocnin-body">
          Deseja <strong>inativar</strong> "{titulo || "esta origem"}"?
          {err ? <div className="ocnin-err">{err}</div> : null}
        </div>
        <footer className="ocnin-foot">
          <button className="ocnin-btn" type="button" onClick={onClose} disabled={busy}>Cancelar</button>
          <button className="ocnin-btn ocnin-btn-warn" type="button" onClick={handleConfirmar} disabled={busy}>
            {busy ? "Inativando..." : "Inativar"}
          </button>
        </footer>
      </div>
    </div>
  );
}

